var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isEditing)?[_c('form-item',_vm._b({},'form-item',_vm.formDataForDisplay,false))]:[_c(_vm.componentName,_vm._b({tag:"component",on:{"change":_vm.onChange}},'component',_vm.formDataForEdit,false))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }